import { render } from "./One.vue?vue&type=template&id=08cf4632&scoped=true"
import script from "./One.vue?vue&type=script&lang=js"
export * from "./One.vue?vue&type=script&lang=js"

import "./One.vue?vue&type=style&index=0&id=08cf4632&scoped=true&lang=css"

import exportComponent from "D:\\dev_workspace\\cy\\web\\linkomweb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08cf4632"]])

export default __exports__